/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFoldoutPanelTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h16v20H4V2zm2 2v16h12V4H6zm6 4H8V6h4v2zm4 0h-2V6h2v2zm0 3v2H8v-2h8zm0 5v2H8v-2h8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFoldoutPanelTemplate as FoldoutPanelTemplate };
